<app-onboarding-header></app-onboarding-header>
<form class="md:max-w-xl md:m-auto" [formGroup]="form">
  <div class="md:max-w-xl md:m-auto flex flex-col items-center mt-6 p-4">
    <img class="flex w-24 h-24 rounded-full"
         src="./assets/icons/email-validation.svg"
         alt="Profile image" />
    <h2 class="text-center">{{'ONBOARDING.PASS.TITLE' | translate}}</h2>
    <p class="text-base text-center">
      {{'ONBOARDING.PASS.DESC' | translate}}
    </p>
    <mat-form-field class="calls-full-width mt-8 mb-4">
      <mat-label>{{'ONBOARDING.PASS.CODE' | translate}}</mat-label>
      <input type="text" matInput formControlName="code" />
    </mat-form-field>

    <mat-form-field class="calls-full-width mb-4">
      <mat-label>{{ 'ONBOARDING.REGISTER.PASS1' | translate }}</mat-label>
      <div class="mt-2">
        <div class="flex items-center rounded-md pl-3 outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
          <input [type]="mostrarPassword1 ? 'text' : 'password'" matInput formControlName="newPassword" />
          <div class="grid shrink-0 grid-cols-1 focus-within:relative">
            <mat-icon class="material-icons-outlined cursor-pointer" id="showpassword1" (click)="mostrarpass1()" title="{{ 'ONBOARDING.LOGIN.'+showpasstext1 | translate }} ">{{icon1}}</mat-icon>

          </div>
        </div>
      </div>
      <mat-error *ngIf="form.get('newPassword')?.hasError('pattern')">
        {{ 'ONBOARDING.REGISTER.WHITE_SPACE' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="calls-full-width mb-4">
      <mat-label>{{ 'ONBOARDING.REGISTER.PASS2' | translate }}</mat-label>
      <div class="mt-2">
        <div class="flex items-center rounded-md pl-3 outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
          <input [type]="mostrarPassword2 ? 'text' : 'password'" matInput formControlName="newPassword2" />
          <div class="grid shrink-0 grid-cols-1 focus-within:relative">
            <mat-icon class="material-icons-outlined cursor-pointer" id="showpassword2" (click)="mostrarpass2()" title="{{ 'ONBOARDING.LOGIN.'+showpasstext2 | translate }} ">{{icon2}}</mat-icon>

          </div>
        </div>
      </div>
      <mat-error *ngIf="form.get('newPassword2')?.hasError('pattern')">
        {{ 'ONBOARDING.REGISTER.WHITE_SPACE' | translate }}
      </mat-error>
    </mat-form-field>

    <app-button (click)="forgotPasswordSubmit()">
      {{'ONBOARDING.PASS.BUTTON' | translate}}
    </app-button>
  </div>
</form>
